import Cookies from 'js-cookie'
import { setUserInfo, removeUserInfo, set30MinutesUserInfo } from '@/util/auth'

export const mutations = {
  SET_LANGUAGE: (state, language) => {
    state.language = language
    Cookies.set('language', language)
  },
  UPDATE_USER_LOCAL_INFO: (state, info) => {
    let mapObj = Object.assign({}, info)
    if (info.programmeTypeName) {
      mapObj = Object.assign({}, mapObj, {
        programmeType: info.programmeTypeName.toLowerCase().includes('anchor')
          ? 0
          : 1
      })
    }
    if (info.eventId) {
      const index = state.eventList.findIndex(v => v.id === info.eventId)
      if (index !== -1) {
        const registerEvent = state.eventList[index]
        state.eventList.splice(
          index,
          1,
          Object.assign({}, registerEvent, {
            isRegisted: true
          })
        )
      }
    }
    state.userInfo = Object.assign({}, state.userInfo, mapObj)
    setUserInfo(Object.assign({}, state.userInfo, mapObj))
  },
  UPDATE_SIMPLE_USER_INFO: (state, userInfo) => {
    state.userInfo = Object.assign({}, state.userInfo, userInfo)
    set30MinutesUserInfo(Object.assign({}, state.userInfo, userInfo))
  },
  EMPTY_USER_LOCAL_INFO: state => {
    state.userInfo = { countryCode: 86 }
    removeUserInfo()
  },
  UPDATE_TOP_EVENT_LIST: (state, list) => {
    state.eventList = list || []
  },
  UPDATE_REGITERED_EVENTS: (state, list) => {
    state.registeredEvents = list || []
  },
  UPDATE_APPROVED_EVENTS: (state, list) => {
    state.approvedEvents = list || []
  },
  UPDATE_LOADING: (state, loading) => {
    state.loading = Object.assign({}, state.loading, loading)
  },
  UPDATE_LOOKUPS: (state, lookup) => {
    state.lookups = Object.assign({}, lookup)
  },
  UPDATE_APPLY_LOOKUPS: (state, lookup) => {
    state.applyLookups = Object.assign({}, lookup)
  },
  UPDATE_ANCHOR_FORM: (state, data) => {
    state.anchorForm = Object.assign({}, data)
  },
  UPDATE_EVENT_CAMPAIGN_ID: (state, id) => {
    state.campaignId = id
  },
  SET_TEMP_FILES: (state, files) => {
    state.tempFiles = files
  },
  SET_TEMP_SURVEY: (state, survey) => {
    state.tempSurvey = survey
  },
  SAVE_VIDEO: (state, video) => {
    state.video = video
  }
}
